import { ACTION_EVENTS } from "../UserAction";
import { createElement } from "../../helpers";
import events from "../../events/EventsObservable";
import SystemConfig, { CONFIG_PARAMS } from "../../system/SystemConfig";

type hPos = "left" | "right" | "center";
type vPos = "top" | "center" | "right";
interface IButtonRequestMsg {
	type: "addButton";
	id: string;
	event?: string;
}
interface IButtonRemoveMsg {
	type: "removeButton";
	id: string;
}
export default class MadnesIframe {
	protected appName: string;
	protected systemConfig: SystemConfig;

	private parent: HTMLElement;
	private wrapper: HTMLElement;
	private container: HTMLElement;
	private frame: HTMLIFrameElement;
	private buttons: HTMLButtonElement[] = [];

	private action: string;
	private closeTimeout: NodeJS.Timeout | undefined;

	constructor({ parent, appName, systemConfig }) {
		this.parent = parent; //#wrapper
		this.wrapper = null;
		this.container = null;
		this.frame = null;
		this.action = ACTION_EVENTS.ACTION_IFRAME_CLOSE;
		this.closeTimeout = undefined;
		this.appName = appName;
		this.systemConfig = systemConfig;

		events.subscribe(ACTION_EVENTS.ACTION_IFRAME_CLOSE, () => this.close());
	}

	get Frame() {
		return this.frame;
	}

	addButton(
		id: string,
		horizontal: hPos,
		vertical: vPos,
		event: string,
		cls = "btn-close"
	) {
		const button = createElement(
			`dynamic-${id}`,
			[
				"mx-iframe-button",
				"mx-button",
				"mx-input",
				"rotate-in-center",
				`h-${horizontal}`,
				`v-${vertical}`,
				cls,
			],
			"button"
		) as HTMLButtonElement;
		if (event)
			button.onclick = () =>
				this.frame.contentWindow.postMessage(
					{ type: "buttonClick", event },
					"*"
				);
		if (id === "close") button.onclick = () => this.closeOnClick();
		this.wrapper.appendChild(button);
		this.buttons.push(button);
	}

	create() {
		this.wrapper = createElement("", ["mx-iframe-wrapper"]);
		this.parent.appendChild(this.wrapper);

		this.container = createElement("", ["mx-iframe-container"]);
		this.wrapper.appendChild(this.container);
		// this.addIOSTouch()

		this.frame = createElement(
			"",
			["mx-iframe"],
			"iframe"
		) as HTMLIFrameElement;
		this.frame.allow = "clipboard-read; clipboard-write";
		this.container.appendChild(this.frame);

		this.frame.contentWindow.parent.addEventListener(
			"message",
			(e: MessageEvent<IButtonRequestMsg | IButtonRemoveMsg>) => {
				if (e.source !== this.frame.contentWindow) return;
				if (e.data.type === "addButton") {
					const buttonConfig = (
						this.systemConfig.get(CONFIG_PARAMS.APP_BUTTONS)[this.appName] as
							| { button: string; position: [vPos, hPos] }[]
							| undefined
					)?.find((el) => el.button === e.data.id);

					this.addButton(
						e.data.id,
						buttonConfig.position[1] ?? "right",
						buttonConfig.position[0] ?? "top",
						e.data.event,
						`btn-${e.data.id}`
					);
					return;
				}
				if (e.data.type === "removeButton") {
					const button = this.buttons.find(
						(el) => el.id === `dynamic-${e.data.id}`
					);
					console.log(button);

					if (!button) return;
					button.remove();
					this.buttons.splice(this.buttons.indexOf(button), 1);
					console.log(this.buttons);
				}
			}
		);

		$(this.wrapper).hide();
	}

	openIframe(src = null) {
		if (this.closeTimeout) clearTimeout(this.closeTimeout);

		if (src) this.setSrc(src);

		this.frame.contentWindow.postMessage({ type: "frameOpen" }, "*");
		$(this.wrapper).show();

		this.container.classList.remove("scale-out-ver-top");
		this.container.classList.add("scale-in-ver-top");

		this.frame.classList.remove("slide-out-bck-center");

		this.frame.classList.add("slide-in-bck-center");
	}

	close() {
		this.frame.classList.remove("slide-in-bck-center");
		this.frame.classList.add("slide-out-bck-center");

		this.container.classList.remove("scale-in-ver-top");
		this.container.classList.add("scale-out-ver-top");

		this.closeTimeout = setTimeout(() => {
			$(this.wrapper).hide();
			this.frame.contentWindow.postMessage({ type: "frameClose" }, "*");
			$(this.frame).css({ opacity: 0 });
		}, 500);
	}

	setSrc(url) {
		this.frame.src = url;
	}

	setCloseAction(action: string): void {
		this.action = action;
	}

	closeOnClick(): void {
		events.dispatch(this.action);
	}
}
